import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../shared/auth/services/authentication.service';

const COMPONENT_SELECTOR = 'wlm-account-card-layout';

@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './account-card-layout.component.html',
  styleUrls: ['./account-card-layout.component.scss'],
  standalone: false,
})
export class AccountCardLayoutComponent implements OnInit {
  constructor(public authService: AuthenticationService) {}

  ngOnInit(): void {}
}
